export const DATETIME_FORMAT_TO_SECONDS = "yyyy-MM-dd'T'HH:mm:ss";
export const DATE_FORMAT_YEAR_MONTH_DATE = 'yyyy-MM-dd';
export const DATE_FORMAT_DATE_MONTH_YEAR_FRENCH = 'jj-MM-aaaa';
export const DATE_FORMAT_DATE_MONTH_YEAR_GERMAN = 'tt-MM-jjjj';
export const DATE_FORMAT_DATE_MONTH_YEAR_ITALIAN = 'gg-mm-aaaa';
export const DATE_FORMAT_DATE_MONTH_YEAR_NORWEGIAN = 'dd-MM-åååå';
export const DATE_FORMAT_US = 'MM/dd/yyyy';

export const DATE_FORMAT_DATE_MONTH_YEAR = 'dd-MM-yyyy';
export const DATE_FORMAT_SHORT_DATE_MONTH_YEAR = 'd-M-yyyy';
export const DATE_FORMAT_DEFAULT = 'dd MMM yyyy';
export const DATE_BIRTHDAY_FORMAT = 'MMM dd yyyy';
export const DATE_FORMAT_SHORT_DAY_MONTH_YEAR = 'd MMM yy';
export const DATE_FORMAT_DAY_SPACE_SHORT_MONTH_NAME = 'dd MMM';
export const DATE_FORMAT_SHORTWEEKDAYNAME_COMMA_DAY_SPACE_SHORTMONTHNAME_SPACE_FULLYEAR =
  'EEE, dd MMM yyyy';
export const DATE_FORMAT_SHORTWEEKDAYNAME_COMMA_DAY_SPACE_SHORTMONTHNAME_SPACE_FULLYEAR_WITHOUT_COMA =
  'EEE dd MMM yyyy';
export const DATE_FORMAT_DAY_DATE_MONTH_PIPE_YEAR = 'EEE, dd MMM|yyyy'
export const DATETIME_FORMAT_MORE_INFO_MODAL = 'HH:mm EEE d MMMM';
export const DATE_FORMAT_YEAR_MONTH = 'yyyy-MM';

export enum DateFormats {
  ABBREVIATED_DAY = 'EEE',
  TWO_DIGIT_DAY_OF_MONTH = 'dd',
  ONE_OR_TWO_DIGIT_DAY_OF_MONTH = 'd',
  DAY_SPACE_SHORT_MONTH_NAME = 'dd MMM',
  USA_TIME_FORMAT = 'h:mma',
  EUROPE_TIME_FORMAT = 'HH:mm',
  ABBREVIATED_DATE_MONTH_FULL_DATE = 'd MMM yyyy',
  ABBREVIATED_DAY_MONTH_FULL_DATE = 'EEE, d MMM yyyy',
  ABBREVIATED_DAY_MONTH_FULL_DATE_SHORT_YEARS = 'EEE, d MMM yy',
  ABBREVIATED_DAY_MONTH = 'EEE, d MMM',
  ABBREVIATED_MONTH_DAY = 'EEE, MMM d',
  FULL_MONTH_FULL_YEAR = 'MMMM yyyy',
  BOARDING_PASS_FORMAT = 'dd-MMM-yyyy',
  LAST_SEARCH_FORMAT = 'd MMM',
  ONLY_YEAR_FORMAT = 'yyyy',
  SHORT_MONTH_YEAR = 'MMM yyyy'
}
